import React from "react";

import StaticLayout from "./StaticLayout";
import Collapsible, { FAQ_QUESTIONS } from "../../components/Collapsible";

export default function FAQPage() {
  return (
    <StaticLayout>
      <div className="section horizontal-page-title">
        <div className="container">
          <div className="content-row">
            <div className="content-row-contents">
              <div className="badge badge-title text-primary-2" />
              <h1 className="heading-3">Frequently Asked Questions</h1>
              <p style={{ color: "white" }}></p>
            </div>
            <div className="justify-center page-title-text">
              <div className="content-row-contents" />
            </div>
          </div>
        </div>
        <div className="decoration-container">
          <img
            src="/landing-page/images/grid-dark.svg"
            alt=""
            className="decoration-grid"
          />
          <div
            data-w-id="35f9b2b5-6f2e-bcc0-b419-0ce254d19861"
            className="decoration-circle bg-primary-3"
          />
        </div>
      </div>

      <div className="container">
        <div className="section-title" style={{ marginBottom: 0 }}>
          <div className="badge badge-title text-white" />
          <h2 className="medium-heading-3">FAQs</h2>

          <div
            className="block-section container cert-container align-items-center mt-30"
            style={{ marginTop: 60 }}
          >
            <div className="block-section-60 font-weight-bold hero">
              <h3>General</h3>
              <Collapsible faqQuestions={FAQ_QUESTIONS.GENERAL_QUESTIONS} />
            </div>

            <div className="block-section-40" style={{ margin: "auto" }}>
              <img
                style={{ maxWidth: 275 }}
                src="/assets/images/faqs/rect1.png"
                alt=""
              />
            </div>
          </div>

          <div
            className="block-section container cert-container align-items-center mt-30"
            style={{ marginTop: 60 }}
          >
            <div className="block-section-60 font-weight-bold hero">
              <h3>Joining the Directory</h3>
              <Collapsible
                faqQuestions={FAQ_QUESTIONS.ONBOARDING_AND_DIRECTORY}
              />
            </div>

            <div className="block-section-40" style={{ margin: "auto" }}>
              <img
                style={{ maxWidth: 275 }}
                src="/assets/images/faqs/rect2.png"
                alt=""
              />
            </div>
          </div>

          <div
            className="block-section container cert-container align-items-center mt-30"
            style={{ marginTop: 60 }}
          >
            <div className="block-section-60 font-weight-bold hero">
              <h3>Certification</h3>
              <Collapsible
                faqQuestions={FAQ_QUESTIONS.CERTIFICATION_QUESTIONS}
              />
            </div>

            <div className="block-section-40" style={{ margin: "auto" }}>
              <img
                style={{ maxWidth: 275 }}
                src="/assets/images/faqs/rect3.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section-large">
        <div className="container">
          <div className="cta-container">
            <h3 className="medium-heading-2">Have more questions?</h3>
            <p className="h5-small-1">
              You can reach out to our team to learn more here.
            </p>
            <div className="cta-action-container">
              <a
                href="mailto:certification@byblack.us"
                className="button w-button"
              >
                Get in touch
              </a>
            </div>
          </div>
        </div>
      </div>
    </StaticLayout>
  );
}
